export default __webpack_public_path__ + "static/media/new-3d-building.c512781b.svg";